<!-- src/components/TrialSignupModalView.vue -->

<template>
    <div>
        <vue-modal 
            v-if="displaySubscriptionNudge"
            :allow-close="false" 
            class="trial-modal">
            <div slot="body">
                <div class="trial-cone"></div>
                <h3>Subscribe to unlock more reports.</h3>
                <p>Sign up for a full subscription to fully use Construct-A-Lead.</p>
            </div>
            <div slot="footer">
              <vue-button
                  type="green large"
                  @click="$router.push({ path: '/Me/Subscription' })">Sign Up</vue-button>
                <vue-button
                    type="large"
                    @click="skipForNow()">Later</vue-button>
            </div>
        </vue-modal>
    </div>
</template>

<script>

import VueModal from '../Shared/VueModal.vue';
import VueButton from '../Shared/VueButton.vue';

export default {    
    
    components: { VueModal, VueButton },
    
    data () {
        return {
          displaySubscriptionNudge: false
        }
    },
    methods: {
      skipForNow() {
        this.$root.$data.auth.user.displaySubscriptionNudge = false;
      }
    },
    watch: {
        '$root.$data.auth.user.displaySubscriptionNudge': {
          handler: function(val) {
            this.displaySubscriptionNudge = val;
          }
        },
      '$route': function(route) {
          if (this.displaySubscriptionNudge) {
            this.skipForNow();
          }
      },
    }
}
</script>

<style>
.trial-modal {
    text-align: center;
}

.trial-modal h3 {
    font-weight: 500;
    font-size: 20px;
    color: #4A4A4A;
}

.trial-modal p {
    font-size: 14px;
    color: #969696;
    padding: 0px 50px 20px;
}

.trial-modal .trial-cone {
    background: url('/images/CAL-Logo-footer.png');
    background-size: 100% 100%;
    width: 69px;
    height: 90px;
    display: inline-block;
}
</style>
